import * as React from 'react';

function LogoBaseSimple(props) {
  return (
    <svg viewBox="0 0 300 300" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150 0C66.8571 0 0 66.8571 0 150C0 232.286 66.8571 300 150 300C232.286 300 300 233.143 300 150C299.143 66.8571 232.286 0 150 0Z"
        fill="#002D6E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.714 136.286C185.143 132 191.143 126 195.428 121.714C203.143 113.143 205.714 102.857 205.714 92.5715C205.714 84.8572 203.143 68.5715 189.428 57.4286C180 49.7143 171.428 46.2858 150.857 46.2858H140.571H139.714H96.8569V246.857H217.714V208.286C217.714 172.286 206.571 147.429 175.714 136.286ZM190.285 236.571H168V169.714H143.143V236.571H123.428V56.5715H143.143C150.857 56.5715 162 58.2858 169.714 67.7143C174 72.8572 176.571 79.7143 177.428 85.7143H142.285V96H177.428C177.428 102 175.714 109.714 169.714 117.429C164.571 124.286 155.143 130.286 142.285 130.286V140.571C176.571 140.571 189.428 162.857 189.428 204.857V236.571H190.285Z"
        fill="white"
      />
    </svg>
  );
}

export default LogoBaseSimple;
